import * as actions from './outOfOffice.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { OutOfOfficeModel } from '@smarttask-common/src/lib/models/Resource/OutOfOfficeModel';

export const oooAdapter = createEntityAdapter<OutOfOfficeModel>({
    selectId: (x) => x.ooo_uuid,
});
export interface OutOfOfficeState extends EntityState<OutOfOfficeModel> {
    selected_ooo_uuid: string;
}

export const initialState: OutOfOfficeState = oooAdapter.getInitialState({
    selected_ooo_uuid: undefined,
});

export function OutOfOfficeReducers(state: OutOfOfficeState = initialState, action: actions.OutOfOfficeActions) {
    switch (action.type) {
        case actions.OutOfOfficeActionTypes.UPDATE_SELECTED_OOO:
            state = { ...state, selected_ooo_uuid: action.selected_ooo_uuid };
            //console.log(state);
            return state;

        case actions.OutOfOfficeActionTypes.ADD_OOO:
            return oooAdapter.addOne(action.ooo, state);

        case actions.OutOfOfficeActionTypes.ADD_OOOS:
            return oooAdapter.addMany(action.ooos, state);

        case actions.OutOfOfficeActionTypes.UPSERT_OOO:
            return oooAdapter.upsertOne(action.ooo, state);

        case actions.OutOfOfficeActionTypes.UPSERT_OOOS:
            return oooAdapter.upsertMany(action.ooos, state);

        case actions.OutOfOfficeActionTypes.UPDATE_OOO:
            return oooAdapter.updateOne(action.ooo, state);

        case actions.OutOfOfficeActionTypes.UPDATE_OOOS:
            return oooAdapter.updateMany(action.ooos, state);

        case actions.OutOfOfficeActionTypes.DELETE_OOO:
            return oooAdapter.removeOne(action.id, state);

        case actions.OutOfOfficeActionTypes.DELETE_OOOS:
            return oooAdapter.removeMany(action.ids, state);

        case actions.OutOfOfficeActionTypes.DELETE_ALL_OOOS:
            return oooAdapter.removeMany(action.ids, state);

        case actions.OutOfOfficeActionTypes.DELETE_ALL:
            return oooAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getOutOfOfficeState = createFeatureSelector<OutOfOfficeState>('ooo');

export const { selectIds, selectEntities, selectAll, selectTotal } = oooAdapter.getSelectors(getOutOfOfficeState);

const getSelectedOutOfOfficeIdState = (state: OutOfOfficeState) => {
    return state.selected_ooo_uuid;
};
export const getSelectedOutOfOfficeId = createSelector(getOutOfOfficeState, getSelectedOutOfOfficeIdState);

export const getSelectedOutOfOffice = createSelector(getOutOfOfficeState, (state: OutOfOfficeState) => {
    if (state.selected_ooo_uuid == undefined) {
        return undefined;
    }
    return state.entities[state.selected_ooo_uuid];
});
